import BaseViz from './BaseViz'
import ScatterPlotChart from '../charts/ScatterPlotChart'
import ScatterDataController from '../viz_behaviors/ScatterDataController'
import { select as d3_select } from 'd3-selection'
export default class ScatterPlotViz extends BaseViz {
  static defaultConfig = {
    ItemsHelper: {
      colorScale: {
        value: 'categorical',
        options: ['categorical'], //['sequential2','sequential3','categorical']
        nonEditable: true,
      },
      colorKey: 'group',
    },
    AxisHelper: {
      x: {
        showTickValues: {
          nonEditable: true,
        },
        tickMatchData: {
          nonEditable: true,
          exposed: false
        }
      },
    },
    TooltipBehavior: {
      getHtml: function (d) {
        return `
        <div class="tip-value important">${d.id}</div>
        <div class="tip-id">
          x: ${this.valueWithUnit(d.x, 'x')} | y: ${this.valueWithUnit(d.y, 'y')} <br/>
          size: ${this.valueWithUnit(d.size)}
        </div>
        <div class="secondary">
          <span class="icon" style="display: inline-block; width: 9px; height: 9px; border-radius: 50%; background: ${this.color(d)}; margin-right: 3px"></span>
          ${d.group}
        </div>
        `
      },
      getItemOffset: function ($el, d) {
        let targetRect = d3_select($el).select('circle').node().getBoundingClientRect()
        return {
          x: targetRect.x + targetRect.width / 2,
          y: targetRect.y + targetRect.height / 2, //- 10
        }
      },
    },
    LegendBehavior: {
      icon: 'circle',
    },
  }
  static chartClass = ScatterPlotChart
  static dataControllerClass = ScatterDataController
}
